import { render, staticRenderFns } from "./EditableCustomField.vue?vue&type=template&id=9889613e&scoped=true"
import script from "./EditableCustomField.vue?vue&type=script&lang=js"
export * from "./EditableCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9889613e",
  null
  
)

export default component.exports